import { Component, Input } from '@angular/core';

@Component({
    selector: 'data-block',
    templateUrl: './data-block.component.html',
    styleUrls: ['./data-block.component.css']
})
export class DataBlockComponent {
    @Input() icon: string = "";
    @Input() showEuro: boolean = false;
    @Input() isEnergy: boolean = true;
    @Input() showPercentage: boolean = false;
    @Input() small: boolean = false;
    @Input() mobile: boolean = false;
    @Input() currentTimeDescription: string = "";
    @Input() blockTitle: string = "";
    @Input() blockValue: number = 0.0;

    constructor() {}
}



// WEBPACK FOOTER //
// ./ClientApp/app/pages/_shared/data-block/data-block.component.ts